import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hideSaveAndCloseDialog } from '../../store/slice/dialogSlice'

const SaveAndCloseDialog = ({ isDisabled, handleSaveAndClose, text, form, isLoading = false }) => {
  const open = useSelector((state) => state.dialogSlice.saveAndCloseDialog)
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(hideSaveAndCloseDialog())
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Save and Close</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>Are you sure you want to save your changes in {text}?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={isLoading || isDisabled}
          onClick={handleSaveAndClose}
          form={form}
          type={form ? 'submit' : 'button'}
        >
          Yes
        </Button>
        <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveAndCloseDialog